import { consumeSsoCallback } from './utils/sso'

// Must be evaluated before ./router creates its web history, so the one-time token never reaches the router.
export const ssoCallback = consumeSsoCallback()
